import React, { useState, useEffect } from "react";
import Preloader from "../Preloader/Preloader";
import "./Stats.css"; // Убедитесь, что создали этот файл

const Stats = () => {
  const [isLoading, setIsLoading] = useState(true);

  const handleIframeLoad = () => {
    setTimeout(() => {
      setIsLoading(false);
    }, 3000);
  };

  return (
    <div className="stats-container">
      {isLoading && <Preloader />}
      <iframe
        className={`stats-frame ${isLoading ? "hidden" : ""}`}
        src="http://192.168.10.123:8502/Опоздания"
        height="950"
        width="100%"
        title="Статистика опозданий"
        onLoad={handleIframeLoad}
      />
    </div>
  );
};

export default Stats;
